import { cloneDeep } from 'lodash';

const loadMenu = (state, payload) => {
  const newState = cloneDeep(state);
  try {
    if (payload.error) {
      newState.error = true;
      return newState;
    }
    newState.categories = payload.categories;
    newState.toppings = payload.toppings;
    newState.products = payload.products;
    newState.services = payload.services;
    newState.place = payload.place;
    newState.users = payload.users;
    newState.loading = false;
    newState.initialized = payload.initialized;
    return newState;
  } catch (error) {
    return state;
  }
};

export { loadMenu };
